var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 0.992828C41.496 0.719511 41.2733 0.5 41 0.5C40.7267 0.5 40.504 0.719511 40.5 0.992828L40.0737 30.711C40 35.851 35.851 40 30.711 40.0737L0.992828 40.5C0.719511 40.504 0.5 40.7267 0.5 41C0.5 41.2733 0.719511 41.496 0.992828 41.5L30.711 41.9263C35.851 42 40 46.149 40.0737 51.289L40.5 81.0072C40.504 81.2805 40.7267 81.5 41 81.5C41.2733 81.5 41.496 81.2805 41.5 81.0072L41.9263 51.289C42 46.149 46.149 42 51.289 41.9263L81.0072 41.5C81.2805 41.496 81.5 41.2733 81.5 41C81.5 40.7267 81.2805 40.504 81.0072 40.5L51.289 40.0737C46.149 40 42 35.851 41.9263 30.711L41.5 0.992828Z",
    fill: "#5D5D5D",
    stroke: "#5D5D5D",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.7399c1491784ee2b5053d20493a4d265.svg";
export { ForwardRef as ReactComponent };